import {
  Button,
  Form,
  Input,
  Typography,
  Row,
  Col,
  message,
  Select,
  Result,
} from "antd";
import React, { useState } from "react";
import { createAccount } from "../../../api/auth.module";
const { Paragraph, Text } = Typography;
function RegisterForm({ setLoginPage }) {
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [created, setCreated] = useState(false);
  const handleSubmit = async (v) => {
    setLoading(true);
    console.log(v);
    const { password, passwordTwo, name, salute, email } = v;
    if (password !== passwordTwo) {
      setErr("Passwords do not match!");
      setLoading(false);
    } else if (password < 5) {
      setErr("Password too short! Should be at least six characters");
      setLoading(true);
    } else {
      const dataPayload = { name, email, password, salute };
      try {
        const dt = await createAccount(dataPayload);
        if (dt) {
          message.success(dt.message);
          setCreated(true);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        message.error(error.response.data.message);
      }
    }
  };
  return (
    <div>
      {!created ? (
        <>
          {" "}
          <Paragraph
            style={{
              textAlign: "center",
              padding: "1rem 0",
              background: "#0c6f8d",
              color: "#f1f1f1",
            }}
          >
            Sign Up for my Services
          </Paragraph>
          {err && (
            <Paragraph
              style={{ color: "#f13", textAlign: "center", padding: "1rem 0" }}
            >
              {err}
            </Paragraph>
          )}
          <Form
            name="register-form"
            onFinish={handleSubmit}
            onChange={() => setErr("")}
          >
            <Row gutter={12}>
              <Col span={6}>
                <Form.Item
                  name="salute"
                  rules={[{ required: true, message: "Salute!" }]}
                >
                  <Select
                    placeholder="Select"
                    options={["Mr.", "Mrs", "Hajj", "Dr", "Ms"].map((x) => ({
                      label: x,
                      value: x,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={18}>
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name!" },
                  ]}
                >
                  <Input placeholder="Full Names" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="email"
              rules={[{ required: true, message: "Please provide email!" }]}
            >
              <Input placeholder="Email address" />
            </Form.Item>
            <Row gutter={12}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please provide password!" },
                  ]}
                >
                  <Input.Password placeholder="Set password" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="passwordTwo">
                  <Input.Password placeholder="Confirm password" />
                </Form.Item>
              </Col>
            </Row>
            <Paragraph style={{ textAlign: "right" }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Sign Up
              </Button>
            </Paragraph>
            <Paragraph style={{ padding: "2rem 0", textAlign: "center" }}>
              Already have an account!{" "}
              <Text
                style={{ cursor: "pointer", color: "#89d" }}
                onClick={() => setLoginPage(true)}
              >
                Sign In
              </Text>
            </Paragraph>
          </Form>
        </>
      ) : (
        <Paragraph>
          <Result
            status="success"
            title="Success!!!"
            subTitle={
              <>
                Thanks for Joining, you can now{" "}
                <Button type="link" onClick={() => setLoginPage(true)}>
                  Login
                </Button>
              </>
            }
          />
        </Paragraph>
      )}
    </div>
  );
}

export default RegisterForm;
